import { Box, Button, FormControl, InputLabel, Select, Slider, Typography } from '@mui/material';
import React, { useState } from 'react'
import { Utilities } from '../../utility/utils';
import NumberInput from './NumberInput';
import { useTranslation } from 'react-i18next';

export interface IRangeSelectComponentProps {
    label: string;
    max: number;
    min: number;
    step?: number;
    width?: string;
    selection: number[] | undefined;
    onRangeSelected: (range: number[] | undefined) => void;
}

const RangeSelectComponent: React.FC<IRangeSelectComponentProps> = ({ label, min, max, step, width, selection, onRangeSelected }) => {
    const [ range, setRange ] = useState([min, max]);
    const [ opened, setOpened ] = useState(false);
    const { t } = useTranslation();

    const onRangeChanged = (event: Event, value: number | (number| undefined)[] ): void => {
        setRange(value as number[]);
    }

    const onApply = () => {
        onRangeSelected(range);
        setOpened(false);
    }

    const onClear = () => {
        onRangeSelected(undefined);
        setOpened(false);
    }

    return <FormControl sx={{ width: width ? width : "200px" }} size='small'>
        <InputLabel id={`select-${label}-label`}>{label}</InputLabel>
        <Select
            labelId={`select-${label}-label`}
            id={`select-${label}`}
            label={label}
            placeholder={label}
            size='small'
            value={selection}
            multiline
            variant='outlined'
            sx={{
                ".MuiOutlinedInput-notchedOutline": {
                    borderWidth: 0
                }
            }}
            onOpen={() => setOpened(true)}
            // onClose={() => setOpened(false)}
            MenuProps={{
                closeAfterTransition: false,
                open: opened,
                onClose: () => setOpened(false),
            }}
            renderValue={(values) => (<Typography>{Utilities.toFriendlyMoneyValue(values[0])} - {Utilities.toFriendlyMoneyValue(values[1])}</Typography>)}
        >
            <Box display={"flex"} flexDirection={"column"} padding={"10px 20px"} gap={"8px"}>
                <Typography fontSize={"16px"} fontWeight={"600"} lineHeight={"24px"}>{t('LibraryOfFundSelectRange')}</Typography>
                <Box width={"100%"} padding={"30px 20px 0 20px"}>
                    <Slider min={min} max={max} valueLabelDisplay={"on"} value={range} onChange={onRangeChanged} step={step ? step : 100000} valueLabelFormat={(v: number) => Utilities.toFriendlyMoneyValue(v)} />
                </Box>
                <Box display={"flex"} justifyContent={"stretch"} gap={"28px"}>
                    <NumberInput label={t('LibraryOfFundSelectRangeMin')} value={range[0]} style={{ width: "120px"}} onChange={(e, value) => onRangeChanged(e as any, [value, range[1]])} />
                    <NumberInput label={t('LibraryOfFundSelectRangeMax')} value={range[1]} style={{ width: "120px"}} onChange={(e, value) => onRangeChanged(e as any, [range[0], value])} />
                </Box>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Button variant='outlined' onClick={onClear}>{t('LibraryOfFundSelectRangeClear')}</Button>
                    <Button variant='contained' onClick={onApply}>{t('LibraryOfFundSelectRangeApply')}</Button>
                </Box>
            </Box>
        </Select>
    </FormControl>
}

export default RangeSelectComponent